const endpoint = "https://api.a-board.world";
// const endpoint = "http://localhost:8080";
//const endpoint = "http://posapi.worklabs.in";
//  const endpoint = "https://api.a-board.tech";
export default endpoint;
